import { Button, styled } from "@mui/material";

const GvSecondaryButtonCustom = styled(Button)(({ theme })=>({
  "textTransform": "none",
  "width": "100%",
  "background": theme.palette.taupe.dark,
  "border": `1px solid ${theme.palette.taupe.light}`,
  "fontWeight": 600,
  "&:hover": {
    background: theme.palette.gray.light,
    color: "black",
    border: `1px solid ${theme.palette.taupe.light}`,
  },
}));

export default GvSecondaryButtonCustom;
